import { render, staticRenderFns } from "./taskFinder.vue?vue&type=template&id=3ed7bfac&"
import script from "./taskFinder.vue?vue&type=script&lang=js&"
export * from "./taskFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports